import React from 'react';

const CartPage = () => {
    return (
        <section 
            id="globalContent" 
            className="global-content cart-page">

            <div className="site-wrapper page-content-wrapper">
                <h1>Cart</h1> 
            </div>
        </section>
    );
};

export default CartPage;